import { Controller } from "@hotwired/stimulus"

const ANALYTICS_SCRIPT_SRC = "https://www.google-analytics.com/analytics.js"

export default class extends Controller {
  static values = { propertyId: String }

  connect() {
    this.loadAnalyticsScript()

    window.ga = window.ga || function() { (window.ga.q = window.ga.q || []).push(arguments) }
    window.ga.l = +new Date()

    window.ga("create", this.propertyIdValue, "auto", { allowLinker: true })
  }

  loadAnalyticsScript() {
    if (document.querySelector(`script[src="${ANALYTICS_SCRIPT_SRC}"]`)) return

    const script = document.createElement("script")
    script.async = true
    script.src = ANALYTICS_SCRIPT_SRC
    document.head.appendChild(script)
  }
}
